'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  { question: 'How to do Marathi Marriage biodata word format download free?', answer: 'To create your free Marathi marriage profile visit MarathiVadhuVarSuchak.com Marathi matrimony.' },
  { question: 'Which is the best Marathi marriage biodata maker?', answer: 'To make best Marathi Marriage biodata visit MarathiVadhuVarSuchak.com Marathi matrimony site.' },
  { question: 'How to use Marathi marriage biodata template free?', answer: 'For free registration, MarathiVadhuVarSuchak.com Marathi matrimonial site is the most trusted site in Maharashtra.' },
  { question: 'How to search best Marathi marriage biodata format?', answer: 'For Marathi Vadhu Var, MarathiVadhuVarSuchak.com Marathi matrimony site is the most trusted brand in Maharashtra state.' },
  { question: 'Which is the best Marathi marriage biodata maker?', answer: 'In Maharashtra state, MarathiVadhuVarSuchak.com site is the best Marathi marriage biodata maker.' },
  { question: 'Which is the trusted Free Marathi marriage biodata maker?', answer: 'For Marathi Vadhu Var, MarathiVadhuVarSuchak.com matrimonial site or mobile app is the trusted Free Marathi marriage biodata maker.' },
  { question: 'Which is the Marathi marriage biodata maker free?', answer: 'From the trust point of view, MarathiVadhuVarSuchak.com is the best free Marathi marriage biodata maker.' },
  { question: 'How to do Marathi marriage biodata template free download?', answer: 'To make best marriage biodata with free template, visit trusted MarathiVadhuVarSuchak.com matrimonial site.' },
  { question: 'Which is the best way for Marathi marriage biodata word format download?', answer: 'For every Marathi community Vadhu Var, MarathiVadhuVarSuchak.com is the best option for free registration.' },
  { question: 'How to download Marathi marriage biodata template?', answer: 'For the best Marathi marriage biodata, download MarathiVadhuVarSuchak.com mobile app.' },
  { question: 'How to create free Marathi marriage biodata?', answer: 'To create free Marathi marriage biodata online, trusted option is MarathiVadhuVarSuchak.com mobile app.' },
  { question: 'Which is the best online Marathi marriage biodata maker?', answer: 'MarathiVadhuVarSuchak.com mobile app is the best online Marathi marriage biodata maker.' },
  { question: 'How to download Marathi marriage biodata word format?', answer: 'To create online Marathi marriage biodata, visit MarathiVadhuVarSuchak.com matrimonial site for free registration.' },
  { question: 'How to download Marathi marriage biodata free?', answer: 'MarathiVadhuVarSuchak.com matrimonial mobile app is the trusted choice to make free Marathi marriage biodata.' },
  { question: 'How to search for Marathi marriage biodata sample?', answer: 'Marathi Vadhu Var can Visit Marathi Vadhu Var Suchak Matrimonial site to create a free Marathi matrimony profile.' },
  { question: 'How to create Marathi marriage biodata online?', answer: 'To create Marathi marriage biodata online, Marathi Vadhu Var can visit MarathiVadhuVarSuchak.com portal.' },
  { question: 'How to do Marathi marriage biodata PDF download?', answer: 'Marathi Vadhu Var Suchak Matrimonial mobile app is the best option for Marathi Vadhu Var to create free matrimonial profile.' },
  { question: 'Which is the best Marathi marriage biodata-word format?', answer: 'Marathi Vadhu Var Suchak Matrimony site is the trusted Marathi matrimony to create free marriage biodata.' },
  { question: 'How to do Marathi marriage biodata format free download?', answer: 'Visit MarathiVadhuVarSuchak.com portal to create free Marathi marriage profile with photo.' },
  { question: 'How to do download for Marathi marriage biodata format PDF?', answer: 'Download MarathiVadhuVarSuchak.com mobile app to create free Marathi marriage profile.' },
];

const communityServices: { label: string; href?: string }[] = [
  { label: "Marathi Marriage biodata word format download free" },
  { label: "Marathi marriage" },
  { label: "Marathi marriage biodata template free" },
  { label: "Marathi marriage biodata format" },
  { label: "Marathi marriage biodata maker" },
  { label: "Free Marathi marriage biodata maker" },
  { label: "Marathi marriage biodata maker free" },
  { label: "Marathi marriage biodata template free download" },
  { label: "Marathi marriage biodata word format download" },
  { label: "Marathi marriage biodata template" },
  { label: "Create free Marathi marriage biodata" },
  { label: "Online Marathi marriage biodata maker" },
  { label: "Marathi marriage biodata word format" },
  { label: "Marathi marriage biodata free" },
  { label: "Marathi marriage biodata sample" },
  { label: "Create Marathi marriage biodata" },
  { label: "Marathi marriage biodata PDF download" },
  { label: "Marathi marriage biodata-word format" },
  { label: "Marathi marriage biodata format free download" },
  { label: "Marathi marriage biodata format PDF" },
  { label: "Marathi Biodata for Marriage" },
  { label: "Marathi Bio Data for Marriage" },
];

export default function MarathiMarriageBiodataClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठी वधू वरांसाठी मॅरेज बायोडेटा"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="marathi_marriage_biodata"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Marathi Marriage biodata for Marathi Vadhu Var"
        items={communityServices}
      />

    </div>
  );
}
